/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from 'irmlib/hooks'

/**
 * @function
 * @description Template
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 24
  const viewBoxHeight = 24
  const [, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g id="MDI_table-border" data-name="MDI / table-border" transform="translate(-0.172)" opacity="0.6">
        <g id="Boundary" transform="translate(0.172)" stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
          <rect width="24" height="24" stroke="none"/>
          <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
        </g>
        <path id="Path_table-border" data-name="Path / table-border" d="M21,19a1,1,0,0,1-1,1H19V18h2v1m-6,1V18h2v2H15m-4,0V18h2v2H11M7,20V18H9v2H7M4,20a1,1,0,0,1-1-1V18H5v2H4M19,4H5A2,2,0,0,0,3,6V8H21V6a1.993,1.993,0,0,0-2-2M5,14H3v2H5V14m0-4H3v2H5V10m16,0H19v2h2V10m0,4H19v2h2V14M11,16V14h2v2H11m0-4V10h2v2H11" transform="translate(0.172)"/>
      </g>
    </svg>
  )
}
